import { CustomEvent } from './CustomEvent';
export class LogEvent extends CustomEvent {
    constructor(data) {
        super('log', {
            detail: data,
        });
    }
}
export class ChangeEvent extends CustomEvent {
    constructor(data) {
        super('change', { detail: data });
    }
}
//# sourceMappingURL=events.js.map